module.exports = __webpack_public_path__ + "static/media/logo-new-tibu.3dda5b65.svg";